const syncNavMegamenuNavbarHeight = () => {
    const r = document.getElementById('nav-megamenu');
    if (!r) return;
    const nb = r.querySelector('.navbar');
    if (!nb) return;
    const h = Math.ceil(nb.getBoundingClientRect().height);
    document.documentElement.style.setProperty('--nav-megamenu-navbar-height', `${h}px`);
};

const syncMobileMegamenuFooterContent = ({ root, currentLevelClass }) => {
    const dyn = root.querySelector('.nav-megamenu__mobile-footer-dynamic');
    if (!dyn) return;
    const cur = root.querySelector(`.${currentLevelClass}`);
    const defaultSrc = root.querySelector('#nav-mm-mobile-footer-default-source');
    let html = '';
    if (cur) {
        const lv = cur.getAttribute('data-level');
        let menuKey = '';
        if (lv === '2') {
            menuKey = cur.getAttribute('data-parent') || '';
        } else if (lv === '3') {
            menuKey = cur.getAttribute('data-mm-root') || '';
        }
        if (menuKey) {
            const safe = String(menuKey).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
            const src = root.querySelector(`.nav-megamenu__mobile-footer-source[data-mm-menu-key="${safe}"]`);
            if (src) {
                html = src.innerHTML;
            }
        } else if (lv === '1' && defaultSrc) {
            html = defaultSrc.innerHTML;
        }
    }
    dyn.innerHTML = html;
};

export { syncNavMegamenuNavbarHeight, syncMobileMegamenuFooterContent };
